import {generalRankingKeysType, generalRankings, rankingLastYear} from "../constants/ranking";
import {IRankingItem} from "../types/IRankingItem";

export function getRankingItems(regionId: number, year?: string) {
    const actualYearString = year || rankingLastYear.toString();
    const rankingList = generalRankings[actualYearString as generalRankingKeysType];

    if (!rankingList) {
        return [];
    }

    return rankingList.filter((cityRecord) => cityRecord.regionId === regionId).sort((prev, next) => prev.regionOrder - next.regionOrder);
}

export function getRankingItemForOffer(offerId: number, year?: string): IRankingItem | undefined {
    const actualYearString = year || rankingLastYear.toString();
    const rankingList = generalRankings[actualYearString as generalRankingKeysType];

    if (!rankingList) {
        return undefined;
    }

    return rankingList.find((item) => item.offerId === offerId);
}
import {generalRankingKeysType, generalRankings, rankingLastYear} from "../constants/ranking";
import {IRankingItem} from "../types/IRankingItem";

export function getRankingItems(regionId: number, year?: string) {
    const actualYearString = year || rankingLastYear.toString();
    const rankingList = generalRankings[actualYearString as generalRankingKeysType];

    if (!rankingList) {
        return [];
    }

    return rankingList.filter((cityRecord) => cityRecord.regionId === regionId).sort((prev, next) => prev.regionOrder - next.regionOrder);
}

export function getRankingItemForOffer(offerId: number, year?: string): IRankingItem | undefined {
    const actualYearString = year || rankingLastYear.toString();
    const rankingList = generalRankings[actualYearString as generalRankingKeysType];

    if (!rankingList) {
        return undefined;
    }

    return rankingList.find((item) => item.offerId === offerId);
}
